import cityService from '@/core/services/city.service';
import { ApiResource } from '@nxtpeople/nxt-styles';
import { City } from '@nxtpeople/nxt-vue-library';
const city = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(_: any, { search }: { search: string }) {
         return await cityService.get({ search }).then((response: ApiResource<Array<City>>) => response.data);
      },
   },
};

export default city;

